import { render, staticRenderFns } from "./XeroConsentModal.vue?vue&type=template&id=567be598&"
import script from "./XeroConsentModal.vue?vue&type=script&lang=js&"
export * from "./XeroConsentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports